<template>
    <div class="changepassword">
        <div class="row align-item-center pt-2 pb-2">
            <div class="col">
                <h2 class="ui text huge-lg big-sm large black mb-0">{{$t('ChangePassword')}}</h2>
            </div>
        </div>
        <hr class="gray-7 mt-0">
        <form>
            <div class="ui form">
                <div class="row mt-2 mb-2 align-items-center">
                    <div class="col-12 col-lg-3 text-lg-right">
                        <label class="ui text medium-sm small">{{$t('Password')}}</label>
                    </div>
                    <div class="col-12 col-lg-6"><input class="ui input text medium-sm small" type="password"  v-model="password"></div>
                </div>
                <div class="row mt-2 mb-2 align-items-center">
                    <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small">{{$t('NewPassword')}}</label></div>
                    <div class="col-12 col-lg-6"><input class="ui input text medium-sm small" type="password" v-model="newpass"></div>
                </div>
                <div class="row mt-2 mb-2 align-items-center">
                    <div class="col-12 col-lg-3 text-lg-right"><label class="ui text medium-sm small">{{$t('ConfirmPassword')}}</label></div>
                    <div class="col-12 col-lg-6"><input class="ui input text medium-sm small" type="password" v-model="confirm"></div>
                </div>
                <div class="row mt-2 mb-2 align-items-center">
                    <div class="col-12 col-lg-3 text-lg-right"><label></label></div>
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <div class="col"><a @click="changePassword" class="ui button theme text medium shadow w-100 py-2 px-2">{{$t('Save')}}</a></div>
                            <div class="col"><a v-on:click="resetText" class="ui button grey text medium shadow w-100 py-2 px-2">{{$t('Cancel')}}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

export default {
  name: 'changepassword',
  components: {},
  data(){
    return {
        password: '',
        newpass: '',
        confirm: ''
    }
  },
  created() {
      
  },
  methods:{
    resetText(){
       this.password = ''
       this.newpass = ''
       this.confirm = ''
    },
    changePassword(){
        this.$parent.$parent.message.title = 'เปลี่ยนรหัสผ่าน'
        if(this.newpass !== this.confirm || this.newpass.length  < 4 ){
            this.$parent.$parent.message.message = 'ยืนยันรหัสผ่านไม่ตรงกัน หรือมากกว่า 4'
            this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
            return
        }
        let data = {
            password: this.password,
            newPassword: this.newpass
        }
        this.$http.put('password',data)
        .then(res => {
                this.resetText()
                this.$parent.$parent.message.message = 'เปลี่ยนรหัสผ่านเรียบร้อย'
                this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
        })
        .catch(error => {
            if(!error.response){
                return
            }
            let message = error.response.data.errors.message
            if(message != ''){
                this.$parent.$parent.message.message = message
                this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
            }
        })
    }
  }
}
</script>
